import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

/** 历史面板收起态（getOnInit 避免首帧闪烁） */
export const historyPanelCollapsedAtom = atomWithStorage(
  "workbench-history-collapsed",
  false,
  undefined,
  { getOnInit: true },
);

/** 工作台统一搜索词：侧栏「搜索历史」输入，联动主区列表过滤（项目网格/文档任务行） */
export const workbenchSearchAtom = atom("");

/**
 * 工作台空间切换（admin 代看）：("__self__" | 具体用户 id)。
 * 哨兵与 KB/文件中心 UserSpaceSwitcher 约定一致；不持久化，进页面默认看自己。
 */
export const workbenchSpaceUserIdAtom = atom<string>("__self__");
